import { AxiosError } from 'axios';

import apiClient from '../../../common/api/apiClient';
import { ApiError } from '../../../common/api/apiResponse';
import { ResetPasswordDto } from './resetPassword.dtos';
import { showNotification } from '../../../common/actionCreators/dispatchNotification';


// endpoints
const resetPasswordUrl = '/account/reset-password';

export const resetPasswordApi = async (request: ResetPasswordDto) => {
  return await apiClient().post(resetPasswordUrl, request)
    .then(() => {
      showNotification('Your password has been reset.', 'success');
      return true;
    })
    .catch((err) => {
      if (err && err.response) {
        const axiosError = err as AxiosError<ApiError>;
        if (axiosError.response) {
          if (axiosError.response.data.error !== undefined) {
            showNotification(axiosError.response.data.error.message, 'error');
          }
          else {
            showNotification('An error occurred while reseting password.', 'error');
          }
        }
      }
      else {
        showNotification('An error occurred while reseting password.');
      }
      throw err;
    });
};
